import { c as _c } from "react/compiler-runtime";
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { Link } from '@/i18n/navigation';
import { AuthenticatedFollowingWithRooms } from '@/services/community';
import { getCardType } from '@/lib/viverse-world-card';
type UserFollowingPublicRoomProps = {
  room: AuthenticatedFollowingWithRooms;
};
function UserFollowingPublicRoom(t0) {
  const $ = _c(12);
  const {
    room
  } = t0;
  const {
    name,
    publicRooms,
    preferredUsername
  } = room;
  const t1 = `/profile/${preferredUsername}`;
  let t2;
  if ($[0] !== name) {
    t2 = <h2 className="header-5 text-vive-primary-20 max-md:text-base">{name}</h2>;
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Link href={t1} className="w-fit">{t2}</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== publicRooms) {
    t4 = publicRooms.map(_temp);
    $[5] = publicRooms;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="no-scrollbar flex w-full flex-col gap-6 max-lg:overflow-scroll max-lg:scroll-smooth md:gap-9"><div className="flex gap-5 md:-mx-2 md:gap-2 lg:flex-wrap lg:gap-2">{t4}</div></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex-gap relative flex flex-col gap-6">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(room_0, index) {
  return <ViverseWorldCard className="max-w-[306px] min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]" key={`followings-card-${room_0.id}-${index}`} info={room_0} hidePremiumBadge={false} cardType={room_0.content_type ? getCardType(room_0.content_type) : "experiences"} />;
}
export default UserFollowingPublicRoom;